import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useMarket } from '../contexts/MarketContext';
import { useTranslation } from '../contexts/LanguageContext';

const MARKET_LANGS = { bg: 'bg', gr: 'el', tr: 'tr', en: 'en' };

/**
 * Wraps a market-specific route section.
 * Sets active market + matching language based on the URL.
 * Does NOT write gc_market_choice (that's only for manual switcher choices).
 */
export default function MarketWrapper({ market }) {
  const { setMarket } = useMarket();
  const { switchLang } = useTranslation();

  useEffect(() => {
    setMarket(market);
    switchLang(MARKET_LANGS[market] || 'bg');
  }, [market, setMarket, switchLang]);

  return <Outlet />;
}
